// TrackFiji V3.3.1 — static topo background for the map side panel (no motion).
// Design: "F · Fleet glance on topo" (TrackFiji_PanelArt_FleetGlance_DevBrief_R1.1). Coordinate labels are decorative.
const BLOB = "M-120 -10 C -110 -70, -30 -95, 30 -80 S 130 -40, 125 10 S 70 85, 0 80 S -130 50, -120 -10 Z";
const RINGS: [number, number, number][] = [[0, 0, 1.3], [4, 2, 1.08], [9, 4, .86], [14, 6, .64], [18, 8, .42], [22, 9, .2]];
const SMALL: [number, number, number][] = [[0, 0, .5], [3, 1, .34], [5, 2, .18]];

export default function PanelArt() {
  return (
    <div className="panel-art" aria-hidden="true">
      <svg viewBox="0 0 320 580" preserveAspectRatio="xMidYMax slice">
        <defs>
          <linearGradient id="pa-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#fff" stopOpacity="0" />
            <stop offset=".32" stopColor="#fff" stopOpacity="1" />
          </linearGradient>
          <mask id="pa-mask"><rect width="320" height="580" fill="url(#pa-fade)" /></mask>
        </defs>
        <g mask="url(#pa-mask)">
          <g className="pa-grid">
            {[80, 160, 240].map((x) => <line key={x} x1={x} y1={0} x2={x} y2={580} />)}
            {[160, 300, 440].map((y) => <line key={y} x1={0} y1={y} x2={320} y2={y} />)}
          </g>
          <g transform="translate(206 452)" className="pa-contour">
            {RINGS.map(([tx, ty, s], i) => <path key={i} className={i === 0 ? "pa-land" : undefined} vectorEffect="non-scaling-stroke" transform={`translate(${tx} ${ty}) scale(${s})`} d={BLOB} />)}
          </g>
          <g transform="translate(78 236) rotate(-24)" className="pa-contour">
            {SMALL.map(([tx, ty, s], i) => <path key={i} className={i === 0 ? "pa-land" : undefined} vectorEffect="non-scaling-stroke" transform={`translate(${tx} ${ty}) scale(${s})`} d={BLOB} />)}
          </g>
          <path className="pa-route" d="M22 566 C 50 546, 62 520, 104 512 S 170 520, 196 490 S 226 432, 262 418" />
          <circle className="pa-stop" cx="104" cy="512" r="3.5" />
          <circle className="pa-stop" cx="196" cy="490" r="3.5" />
          <g transform="translate(262 418)">
            <circle className="pa-ring" r="15" />
            <path className="pa-pin" d="M0 -16 C -6 -16 -9 -11 -9 -7 C -9 -1 0 6 0 6 C 0 6 9 -1 9 -7 C 9 -11 6 -16 0 -16 Z" />
            <circle r="3" cy="-8" fill="#fff" />
          </g>
          <g className="pa-label">
            <text x="84" y="572">177°24′E</text><text x="164" y="572">177°27′E</text><text x="244" y="572">177°30′E</text>
            <text x="6" y="436">17°46′S</text>
          </g>
        </g>
      </svg>
    </div>
  );
}
